export const TIMEZONE_OPTIONS = [
  { value: 'UTC', label: 'UTC - Coordinated Universal Time (UTC+0)' },
  { value: 'America/New_York', label: 'America/New_York - Eastern Time (UTC-5/-4)' },
  { value: 'America/Chicago', label: 'America/Chicago - Central Time (UTC-6/-5)' },
  { value: 'America/Denver', label: 'America/Denver - Mountain Time (UTC-7/-6)' },
  { value: 'America/Los_Angeles', label: 'America/Los_Angeles - Pacific Time (UTC-8/-7)' },
  { value: 'America/Anchorage', label: 'America/Anchorage - Alaska Time (UTC-9/-8)' },
  { value: 'Pacific/Honolulu', label: 'Pacific/Honolulu - Hawaii Time (UTC-10)' },
  { value: 'America/Toronto', label: 'America/Toronto - Eastern Canada (UTC-5/-4)' },
  { value: 'America/Vancouver', label: 'America/Vancouver - Pacific Canada (UTC-8/-7)' },
  { value: 'America/Mexico_City', label: 'America/Mexico_City - Mexico (UTC-6/-5)' },
  { value: 'America/Guatemala', label: 'America/Guatemala - Central America (UTC-6)' },
  { value: 'America/Bogota', label: 'America/Bogota - Colombia (UTC-5)' },
  { value: 'America/Lima', label: 'America/Lima - Peru (UTC-5)' },
  { value: 'America/Sao_Paulo', label: 'America/Sao_Paulo - Brazil (UTC-3/-2)' },
  { value: 'America/Argentina/Buenos_Aires', label: 'America/Argentina/Buenos_Aires - Argentina (UTC-3)' },
  { value: 'America/Santiago', label: 'America/Santiago - Chile (UTC-4/-3)' },
  { value: 'America/Caracas', label: 'America/Caracas - Venezuela (UTC-4)' },
  { value: 'Europe/London', label: 'Europe/London - United Kingdom (UTC+0/+1)' },
  { value: 'Europe/Dublin', label: 'Europe/Dublin - Ireland (UTC+0/+1)' },
  { value: 'Europe/Paris', label: 'Europe/Paris - France (UTC+1/+2)' },
  { value: 'Europe/Berlin', label: 'Europe/Berlin - Germany (UTC+1/+2)' },
  { value: 'Europe/Rome', label: 'Europe/Rome - Italy (UTC+1/+2)' },
  { value: 'Europe/Madrid', label: 'Europe/Madrid - Spain (UTC+1/+2)' },
  { value: 'Europe/Amsterdam', label: 'Europe/Amsterdam - Netherlands (UTC+1/+2)' },
  { value: 'Europe/Brussels', label: 'Europe/Brussels - Belgium (UTC+1/+2)' },
  { value: 'Europe/Vienna', label: 'Europe/Vienna - Austria (UTC+1/+2)' },
  { value: 'Europe/Zurich', label: 'Europe/Zurich - Switzerland (UTC+1/+2)' },
  { value: 'Europe/Prague', label: 'Europe/Prague - Czech Republic (UTC+1/+2)' },
  { value: 'Europe/Warsaw', label: 'Europe/Warsaw - Poland (UTC+1/+2)' },
  { value: 'Europe/Stockholm', label: 'Europe/Stockholm - Sweden (UTC+1/+2)' },
  { value: 'Europe/Oslo', label: 'Europe/Oslo - Norway (UTC+1/+2)' },
  { value: 'Europe/Copenhagen', label: 'Europe/Copenhagen - Denmark (UTC+1/+2)' },
  { value: 'Europe/Helsinki', label: 'Europe/Helsinki - Finland (UTC+2/+3)' },
  { value: 'Europe/Athens', label: 'Europe/Athens - Greece (UTC+2/+3)' },
  { value: 'Europe/Istanbul', label: 'Europe/Istanbul - Turkey (UTC+3)' },
  { value: 'Europe/Moscow', label: 'Europe/Moscow - Russia (UTC+3)' },
  { value: 'Europe/Kiev', label: 'Europe/Kiev - Ukraine (UTC+2/+3)' },
  { value: 'Asia/Dubai', label: 'Asia/Dubai - UAE (UTC+4)' },
  { value: 'Asia/Riyadh', label: 'Asia/Riyadh - Saudi Arabia (UTC+3)' },
  { value: 'Asia/Kuwait', label: 'Asia/Kuwait - Kuwait (UTC+3)' },
  { value: 'Asia/Qatar', label: 'Asia/Qatar - Qatar (UTC+3)' },
  { value: 'Asia/Bahrain', label: 'Asia/Bahrain - Bahrain (UTC+3)' },
  { value: 'Asia/Muscat', label: 'Asia/Muscat - Oman (UTC+4)' },
  { value: 'Asia/Doha', label: 'Asia/Doha - Qatar (UTC+3)' },
  { value: 'Asia/Baghdad', label: 'Asia/Baghdad - Iraq (UTC+3)' },
  { value: 'Asia/Tehran', label: 'Asia/Tehran - Iran (UTC+3:30/+4:30)' },
  { value: 'Asia/Jerusalem', label: 'Asia/Jerusalem - Israel (UTC+2/+3)' },
  { value: 'Asia/Beirut', label: 'Asia/Beirut - Lebanon (UTC+2/+3)' },
  { value: 'Asia/Damascus', label: 'Asia/Damascus - Syria (UTC+2/+3)' },
  { value: 'Asia/Amman', label: 'Asia/Amman - Jordan (UTC+2/+3)' },
  { value: 'Asia/Yerevan', label: 'Asia/Yerevan - Armenia (UTC+4)' },
  { value: 'Asia/Baku', label: 'Asia/Baku - Azerbaijan (UTC+4)' },
  { value: 'Asia/Tbilisi', label: 'Asia/Tbilisi - Georgia (UTC+4)' },
  { value: 'Asia/Karachi', label: 'Asia/Karachi - Pakistan (UTC+5)' },
  { value: 'Asia/Kolkata', label: 'Asia/Kolkata - India (UTC+5:30)' },
  { value: 'Asia/Kathmandu', label: 'Asia/Kathmandu - Nepal (UTC+5:45)' },
  { value: 'Asia/Dhaka', label: 'Asia/Dhaka - Bangladesh (UTC+6)' },
  { value: 'Asia/Colombo', label: 'Asia/Colombo - Sri Lanka (UTC+5:30)' },
  { value: 'Asia/Kabul', label: 'Asia/Kabul - Afghanistan (UTC+4:30)' },
  { value: 'Asia/Tashkent', label: 'Asia/Tashkent - Uzbekistan (UTC+5)' },
  { value: 'Asia/Dushanbe', label: 'Asia/Dushanbe - Tajikistan (UTC+5)' },
  { value: 'Asia/Bishkek', label: 'Asia/Bishkek - Kyrgyzstan (UTC+6)' },
  { value: 'Asia/Ashgabat', label: 'Asia/Ashgabat - Turkmenistan (UTC+5)' },
  { value: 'Asia/Almaty', label: 'Asia/Almaty - Kazakhstan (UTC+6)' },
  { value: 'Asia/Shanghai', label: 'Asia/Shanghai - China (UTC+8)' },
  { value: 'Asia/Hong_Kong', label: 'Asia/Hong_Kong - Hong Kong (UTC+8)' },
  { value: 'Asia/Taipei', label: 'Asia/Taipei - Taiwan (UTC+8)' },
  { value: 'Asia/Tokyo', label: 'Asia/Tokyo - Japan (UTC+9)' },
  { value: 'Asia/Seoul', label: 'Asia/Seoul - South Korea (UTC+9)' },
  { value: 'Asia/Pyongyang', label: 'Asia/Pyongyang - North Korea (UTC+9)' },
  { value: 'Asia/Ulaanbaatar', label: 'Asia/Ulaanbaatar - Mongolia (UTC+8)' },
  { value: 'Asia/Singapore', label: 'Asia/Singapore - Singapore (UTC+8)' },
  { value: 'Asia/Kuala_Lumpur', label: 'Asia/Kuala_Lumpur - Malaysia (UTC+8)' },
  { value: 'Asia/Bangkok', label: 'Asia/Bangkok - Thailand (UTC+7)' },
  { value: 'Asia/Jakarta', label: 'Asia/Jakarta - Indonesia West (UTC+7)' },
  { value: 'Asia/Makassar', label: 'Asia/Makassar - Indonesia Central (UTC+8)' },
  { value: 'Asia/Jayapura', label: 'Asia/Jayapura - Indonesia East (UTC+9)' },
  { value: 'Asia/Manila', label: 'Asia/Manila - Philippines (UTC+8)' },
  { value: 'Asia/Ho_Chi_Minh', label: 'Asia/Ho_Chi_Minh - Vietnam (UTC+7)' },
  { value: 'Asia/Phnom_Penh', label: 'Asia/Phnom_Penh - Cambodia (UTC+7)' },
  { value: 'Asia/Vientiane', label: 'Asia/Vientiane - Laos (UTC+7)' },
  { value: 'Asia/Yangon', label: 'Asia/Yangon - Myanmar (UTC+6:30)' },
  { value: 'Asia/Brunei', label: 'Asia/Brunei - Brunei (UTC+8)' },
  { value: 'Africa/Cairo', label: 'Africa/Cairo - Egypt (UTC+2)' },
  { value: 'Africa/Lagos', label: 'Africa/Lagos - Nigeria (UTC+1)' },
  { value: 'Africa/Nairobi', label: 'Africa/Nairobi - Kenya (UTC+3)' },
  { value: 'Africa/Johannesburg', label: 'Africa/Johannesburg - South Africa (UTC+2)' },
  { value: 'Africa/Casablanca', label: 'Africa/Casablanca - Morocco (UTC+0/+1)' },
  { value: 'Africa/Algiers', label: 'Africa/Algiers - Algeria (UTC+1)' },
  { value: 'Africa/Tunis', label: 'Africa/Tunis - Tunisia (UTC+1)' },
  { value: 'Africa/Tripoli', label: 'Africa/Tripoli - Libya (UTC+2)' },
  { value: 'Africa/Khartoum', label: 'Africa/Khartoum - Sudan (UTC+2)' },
  { value: 'Africa/Addis_Ababa', label: 'Africa/Addis_Ababa - Ethiopia (UTC+3)' },
  { value: 'Africa/Dar_es_Salaam', label: 'Africa/Dar_es_Salaam - Tanzania (UTC+3)' },
  { value: 'Africa/Kinshasa', label: 'Africa/Kinshasa - DR Congo West (UTC+1)' },
  { value: 'Africa/Lubumbashi', label: 'Africa/Lubumbashi - DR Congo East (UTC+2)' },
  { value: 'Africa/Accra', label: 'Africa/Accra - Ghana (UTC+0)' },
  { value: 'Africa/Abidjan', label: 'Africa/Abidjan - Ivory Coast (UTC+0)' },
  { value: 'Australia/Sydney', label: 'Australia/Sydney - Eastern Australia (UTC+10/+11)' },
  { value: 'Australia/Melbourne', label: 'Australia/Melbourne - Victoria (UTC+10/+11)' },
  { value: 'Australia/Brisbane', label: 'Australia/Brisbane - Queensland (UTC+10)' },
  { value: 'Australia/Perth', label: 'Australia/Perth - Western Australia (UTC+8)' },
  { value: 'Australia/Adelaide', label: 'Australia/Adelaide - South Australia (UTC+9:30/+10:30)' },
  { value: 'Australia/Darwin', label: 'Australia/Darwin - Northern Territory (UTC+9:30)' },
  { value: 'Pacific/Auckland', label: 'Pacific/Auckland - New Zealand (UTC+12/+13)' },
  { value: 'Pacific/Fiji', label: 'Pacific/Fiji - Fiji (UTC+12/+13)' },
  { value: 'Pacific/Tahiti', label: 'Pacific/Tahiti - French Polynesia (UTC-10)' },
  { value: 'Pacific/Guam', label: 'Pacific/Guam - Guam (UTC+10)' },
  { value: 'Pacific/Samoa', label: 'Pacific/Samoa - Samoa (UTC+13)' },
  { value: 'Pacific/Tongatapu', label: 'Pacific/Tongatapu - Tonga (UTC+13)' }
];
